import { COOKIES, DOMAIN } from '../constants';

export const isDesktop = () => {
    const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return clientWidth > 767;
};

export const isValidDate = (day, month, year) => {
    if (year.length === 4) {
        const d = new Date(year, month - 1, day);

        // Set a lower limit for year birth.
        // Based on BE, it's current year minus 100 minus 18 (age check)
        const diff = (new Date()).getFullYear() - parseInt(year) - 100 - 18;

        if (diff > 0) {
            return false;
        }

        return d.getFullYear() === parseInt(year) && d.getMonth() + 1 === parseInt(month) && d.getDate() === parseInt(day);
    } else {
        return false;
    }

}

export const calculateAge = (day, month, year) => {
    const today = new Date();
    const birthDate = new Date(year, month - 1, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    const d = today.getDay() - birthDate.getDay();

    if (age === 0 && (m > 0 || (m === 0 && d >= 0))) {
        age = 1;
    } else if (age === 18 && (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))) {
        age -= 1;
    } else if (age === 100 && (m > 0 || (m === 0 && today.getDate() > birthDate.getDate()))) {
        age += 1;
    }

    return age;
};

export const putDataIntoDataLayer = (data) => {
    if (window.dataLayer !== undefined) {
        window.dataLayer.push(data);
    }
};



export const setCookie = (cname, cvalue) => {
    const d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days
    const secure = location.protocol === 'https:' ? 'secure;' : '';
    const sameSiteCookie = 'samesite=none;';
    document.cookie = `${cname}=${cvalue};expires=${d.toGMTString()};path=/;domain=${DOMAIN};${secure}${sameSiteCookie}`;
    //document.cookie = `${cname}=${cvalue};expires=${d.toGMTString()};path=/;`;
};

export const getCookie = (cname) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    let cookie = '';
    for (let i = 0; i < ca.length; i += 1) {
        const c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            cookie = c.substring(name.length, c.length);
            break;
        }
    }
    return cookie;
};

export const invalidateBtagCookie = () => {
    document.cookie = `${COOKIES.BTAG
    }=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${DOMAIN};path=/`;
};

export const invalidatePromocodeCookie = () => {
    document.cookie = `${COOKIES.PROMOCODE
    }=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${DOMAIN};path=/`;
};

export const detectBtagPromocodeFromQS = () => {
    const urlSearchParams = new URLSearchParams(document.location.search);

    // es: btag=a_8023b_3c_717509528&s1=&promocode=t1
    const btag = urlSearchParams.get('btag');
    const promocode = urlSearchParams.get('promocode');

    if (btag && promocode) {
        setCookie(COOKIES.BTAG, btag);
        setCookie(COOKIES.PROMOCODE, promocode);
        setCookie(COOKIES.REG_QUERY_URI,
            decodeURIComponent(window.location.search.slice(1, window.location.search.length)));
    } else if (promocode) {
        setCookie(COOKIES.PROMOCODE, promocode);
        invalidateBtagCookie();
        setCookie(COOKIES.REG_QUERY_URI,
            decodeURIComponent(window.location.search.slice(1, window.location.search.length)));
    } else if (btag) {
        setCookie(COOKIES.BTAG, btag);
        invalidatePromocodeCookie();
        setCookie(COOKIES.REG_QUERY_URI,
            decodeURIComponent(window.location.search.slice(1, window.location.search.length)));
    }
};
